import React from 'react';
import { Text } from '../Text';

const UtilityCallPermissionPreview = ({ content }) => {
  return (
    <>
      {/* BODY */}
      <div className="mx-2 mt-2">
        {content && (
          <Text type="sub-heading" style={{ whiteSpace: 'pre-line' }}>
            {content}
          </Text>
        )}
      </div>

      {/* PERMISSION CARD */}
      <div className="mx-2 mt-2 mb-2">
        <div
          style={{
            border: '1px solid #e0e0e0',
            borderRadius: '10px',
            padding: '12px',
            background: '#fff',
          }}
        >
          {/* HEADER */}
          <div className="flex align-items-center gap-2 mb-2">
            <i className="pi pi-phone" style={{ color: '#25D366' }}></i>
            <Text type="sub-heading">
              Can <b>Business Name</b> call you?
            </Text>
          </div>

          {/* SUBTEXT */}
          <Text type="sub-heading" color="grey" style={{ fontSize: '0.75rem' }}>
            Pulled from your WhatsApp Business profile
          </Text>

          {/* DIVIDER */}
          <div
            style={{
              borderTop: '1px solid #eee',
              margin: '10px 0',
            }}
          />

          {/* CTA */}
          <div className="flex justify-content-center mb-2">
            <Text type="sub-heading" color="#25D366">
              Choose Preferences
            </Text>
          </div>

          {/* OPTIONS */}
          <div className="flex justify-content-between text-xs">
            <span style={{ color: '#22c55e' }}>✔ Allow</span>
            <span style={{ color: '#ef4444' }}>✖ Don’t Allow</span>
            <span>⏰ Remind Me</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default UtilityCallPermissionPreview;
